'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["handleColorChange", "renderColorPicker"],
  _excluded2 = ["contextualNodeAttributes"];
import { useTheme } from 'foundations-theming/utils';
import tinymce from 'tinymce';
import ColorPickerToolbarButton from 'rich-text-lib/components/toolbar/ColorPickerToolbarButton';
import { BackgroundColorIcon } from 'foundations-assets';
import { getColorPicker } from '../../../components/ColorPicker';
import { CANVAS_FILL_COLOR } from '../../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const FillColorButton = _ref => {
  let {
      handleColorChange,
      renderColorPicker
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trellisTheme = useTheme();
  const {
      contextualNodeAttributes
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  const {
    fillColor,
    fillColorTooltip,
    activeElement
  } = contextualNodeAttributes;
  return /*#__PURE__*/_jsx(ColorPickerToolbarButton, Object.assign({
    "data-test-id": "color-picker-fillcolor",
    tooltip: fillColorTooltip,
    icon: "backgroundColor",
    Icon: BackgroundColorIcon,
    color: fillColor,
    defaultColor: trellisTheme.color['border-core-on-fill-default'],
    defaultAlpha: 0,
    onColorChange: handleColorChange.bind(null, activeElement),
    renderColorPicker: renderColorPicker
  }, rest));
};
export function addContextualFillColorControl(editor) {
  const handleColorChange = (target, color) => {
    editor.fire('hsFillColorChange', {
      target,
      color
    });
  };
  const ColorPicker = getColorPicker(editor, {
    includeAlpha: false
  });
  const renderColorPicker = renderProps => {
    // Alpha defaults to 0 when there is no `fillColor`
    const showResetToDefault = renderProps.alpha !== 0;
    return /*#__PURE__*/_jsx(ColorPicker, Object.assign({}, renderProps, {
      showResetToDefault: showResetToDefault
    }));
  };
  tinymce.canvas.addButton(editor, CANVAS_FILL_COLOR, {
    renderControl: props => /*#__PURE__*/_jsx(FillColorButton, Object.assign({
      handleColorChange: handleColorChange,
      renderColorPicker: renderColorPicker
    }, props))
  });
}